import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yiqi",
  "use": "icon-yiqi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yiqi\"><defs><style type=\"text/css\"></style></defs><path d=\"M945.6 94.4H78.4C52.8 94.4 32 115.2 32 140.8v619.2c0 25.6 20.8 46.4 46.4 46.4h294.4v76.8l-62.4 62.4v16h403.2v-16l-62.4-62.4v-76.8h294.4c25.6 0 46.4-20.8 46.4-46.4V140.8c0-25.6-20.8-46.4-46.4-46.4z m-16 588.8H94.4V156.8h836.8v526.4h-1.6z\" p-id=\"2023\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yiqi.svg
// module id = iSEn
// module chunks = 77